import { render, staticRenderFns } from "./GoodReturnCreateView.vue?vue&type=template&id=3af1a48d"
import script from "./GoodReturnCreateView.vue?vue&type=script&lang=js"
export * from "./GoodReturnCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports